export enum UploadSecureDocumentActionType {
  GetOrganizationInfo = 'uploadSecureDocument/getOrganizationInfo',
  GetOrganizationInfoSuccess = 'uploadSecureDocument/getOrganizationInfoSuccess',
  GetOrganizationInfoFailure = 'uploadSecureDocument/getOrganizationInfoFailure',
  UploadSecureDocument = 'uploadSecureDocument/uploadSecureDocument',
  UploadSecureDocumentSuccess = 'uploadSecureDocument/uploadSecureDocumentSuccess',
  UploadSecureDocumentFailure = 'uploadSecureDocument/uploadSecureDocumentFailure',
}
